import { observer } from 'mobx-react';
import { FC, memo, useEffect } from 'react';
import { PreviousOrderModalProductInfo } from './components/PreviousOrderModalProductInfo/PreviousOrderModalProductInfo';
import { PreviousOrderModalProductNote } from './components/PreviousOrderModalProductNote/PreviousOrderModalProductNote';
import { PreviousOrderModalProductTotal } from './components/PreviousOrderModalProductTotal/PreviousOrderModalProductTotal';
import { PreviousOrderModalHeader } from './containers/PreviousOrderModalHeader/PreviousOrderModalHeader';
import { PreviousOrderModalProducts } from './containers/PreviousOrderModalProducts/PreviousOrderModalProducts';
import { previousOrderModalStore } from './store/previousOrderModalStore';
import { IPreviousOrderModal } from './types/previousOrderModal';
import ModalFooter from 'src/view/components/Controls/Modal/ModalFooter/ModalFooter';
import ModalContent from 'src/view/components/Controls/Modal/ModalContent/ModalContent';
import ModalBackground from 'src/view/components/Controls/Modal/ModalBackground/ModalBackground';
import CustomModalComponent from 'src/view/components/Controls/Modal/Modal';

export const PreviousOrderModal: FC<IPreviousOrderModal> = memo(
  observer((props: IPreviousOrderModal): JSX.Element => {
    useEffect(() => {
      previousOrderModalStore.init(props);
    }, []);

    return (
      <CustomModalComponent isOpen onRequestClose={previousOrderModalStore.closeModal} withCloseIcon modalMaxWidth={610} className="order-modal">
        <ModalBackground>
          <PreviousOrderModalHeader />

          <ModalContent>
            <PreviousOrderModalProductInfo />
            <PreviousOrderModalProducts />
          </ModalContent>

          <ModalFooter className="flex-column">
            <PreviousOrderModalProductNote />
            <PreviousOrderModalProductTotal />
          </ModalFooter>
        </ModalBackground>
      </CustomModalComponent>
    );
  })
);
